import type { IconSvgObject } from './types';

const ArrowLeftToLineIcon: IconSvgObject = [
  ["path", { d: "M8 12L21 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 6L3 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 7C12 7 7.00001 10.6824 7 12C6.99999 13.3176 12 17 12 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowLeftToLineIcon;
